<template>
  <div>
    <div
      :class="{
        [$style.topbar]: true,
        [$style.topbarGray]: settings.isGrayTopbar,
      }"
    >
      <div :class="$style.logoContainer">
        <!-- <div :class="$style.logo">
              <img
                src="resources/images/logo.svg"
                class="mr-2"
                alt="Clean UI"
              />
              <div :class="$style.name">{{ settings.logo }}</div>
              <div
                v-if="settings.logo === 'Clean UI Pro'"
                :class="$style.descr"
              >
                Vue
              </div>
            </div> -->
        <div :class="$style.name">
          SCG Debenture Club
        </div>
      </div>
      <div class="d-none d-sm-block">
        <!-- <span class="mr-2">Don't have an account?</span> -->
        <router-link to="/auth/login" class="font-size-16 kit__utils__link">
          {{ $t('Sign in') }}
        </router-link>
      </div>
    </div>
    <router-view style="padding: 1rem;" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'PublicLayout',
  computed: mapState(['settings']),
  data: function () {
    return {
      mode: process.env.NODE_ENV,
    };
  },
};
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>
